// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file src/protos/content_management/cms.teacher.questions.apis.proto (package geneo.cms.teacher.questions.upload.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { APIResponse_CodeEnum, APIResponse_StatusEnum } from "@protos/common/common.db_pb";
import { ModuleQuestionBankTag, Question, QuestionBank } from "@protos/content_management/content.db_pb";

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.DownloadTeacherQuestionsTemplateRequest
 */
export class DownloadTeacherQuestionsTemplateRequest extends Message<DownloadTeacherQuestionsTemplateRequest> {
  /**
   * Course ID
   *
   * @generated from field: int32 subject_id = 1;
   */
  subjectId = 0;

  /**
   * @generated from field: int64 teacher_id = 2;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 school_id = 3;
   */
  schoolId = 0;

  /**
   * Optional: Section/Class ID for context-specific template data
   *
   * @generated from field: optional int64 section_id = 4;
   */
  sectionId?: bigint;

  constructor(data?: PartialMessage<DownloadTeacherQuestionsTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.DownloadTeacherQuestionsTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadTeacherQuestionsTemplateRequest {
    return new DownloadTeacherQuestionsTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadTeacherQuestionsTemplateRequest {
    return new DownloadTeacherQuestionsTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadTeacherQuestionsTemplateRequest {
    return new DownloadTeacherQuestionsTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadTeacherQuestionsTemplateRequest | PlainMessage<DownloadTeacherQuestionsTemplateRequest> | undefined, b: DownloadTeacherQuestionsTemplateRequest | PlainMessage<DownloadTeacherQuestionsTemplateRequest> | undefined): boolean {
    return proto3.util.equals(DownloadTeacherQuestionsTemplateRequest, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.DownloadTeacherQuestionsTemplateResponse
 */
export class DownloadTeacherQuestionsTemplateResponse extends Message<DownloadTeacherQuestionsTemplateResponse> {
  /**
   * Relative path in GCS bucket (e.g., "teacher-questions/templates/template-1234.xlsx")
   *
   * @generated from field: string gcs_relative_path = 1;
   */
  gcsRelativePath = "";

  /**
   * Bucket name
   *
   * @generated from field: string bucket_name = 2;
   */
  bucketName = "";

  /**
   * Signed URL for download
   *
   * @generated from field: string signed_url = 3;
   */
  signedUrl = "";

  /**
   * Original file name
   *
   * @generated from field: string file_name = 4;
   */
  fileName = "";

  constructor(data?: PartialMessage<DownloadTeacherQuestionsTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.DownloadTeacherQuestionsTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gcs_relative_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bucket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "signed_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadTeacherQuestionsTemplateResponse {
    return new DownloadTeacherQuestionsTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadTeacherQuestionsTemplateResponse {
    return new DownloadTeacherQuestionsTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadTeacherQuestionsTemplateResponse {
    return new DownloadTeacherQuestionsTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadTeacherQuestionsTemplateResponse | PlainMessage<DownloadTeacherQuestionsTemplateResponse> | undefined, b: DownloadTeacherQuestionsTemplateResponse | PlainMessage<DownloadTeacherQuestionsTemplateResponse> | undefined): boolean {
    return proto3.util.equals(DownloadTeacherQuestionsTemplateResponse, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.UpsertTeacherQuestionsRequest
 */
export class UpsertTeacherQuestionsRequest extends Message<UpsertTeacherQuestionsRequest> {
  /**
   * GCS file path (signed URL or gs:// URI)
   *
   * @generated from field: string gcs_file_path = 1;
   */
  gcsFilePath = "";

  /**
   * Course ID
   *
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: int64 teacher_id = 3;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 school_id = 4;
   */
  schoolId = 0;

  /**
   * Optional: Section/Class ID for tracking which class these questions are for
   *
   * @generated from field: optional int64 section_id = 5;
   */
  sectionId?: bigint;

  /**
   * If true, update question banks and module mappings. Default: true for new uploads
   *
   * @generated from field: bool update_question_banks = 6;
   */
  updateQuestionBanks = false;

  /**
   * If true, creates new QB. If false, adds to existing QB (if question_bank_id provided)
   *
   * @generated from field: bool create_new_question_bank = 7;
   */
  createNewQuestionBank = false;

  /**
   * If provided and create_new_question_bank=false, adds questions to this QB
   *
   * @generated from field: optional string existing_question_bank_id = 8;
   */
  existingQuestionBankId?: string;

  /**
   * Optional: List of allowed module IDs. If provided, all uploaded questions must belong to these modules
   *
   * @generated from field: repeated int32 module_ids = 9;
   */
  moduleIds: number[] = [];

  constructor(data?: PartialMessage<UpsertTeacherQuestionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.UpsertTeacherQuestionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gcs_file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "update_question_banks", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "create_new_question_bank", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "existing_question_bank_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpsertTeacherQuestionsRequest {
    return new UpsertTeacherQuestionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpsertTeacherQuestionsRequest {
    return new UpsertTeacherQuestionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpsertTeacherQuestionsRequest {
    return new UpsertTeacherQuestionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpsertTeacherQuestionsRequest | PlainMessage<UpsertTeacherQuestionsRequest> | undefined, b: UpsertTeacherQuestionsRequest | PlainMessage<UpsertTeacherQuestionsRequest> | undefined): boolean {
    return proto3.util.equals(UpsertTeacherQuestionsRequest, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.UpsertTeacherQuestionsResponse
 */
export class UpsertTeacherQuestionsResponse extends Message<UpsertTeacherQuestionsResponse> {
  /**
   * @generated from field: geneo.common.db.APIResponse.StatusEnum status = 1;
   */
  status = APIResponse_StatusEnum.STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.common.db.APIResponse.CodeEnum code = 2;
   */
  code = APIResponse_CodeEnum.UNDEFINED;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * List of validation errors if any
   *
   * @generated from field: repeated geneo.cms.teacher.questions.upload.apis.UploadValidationError validation_errors = 4;
   */
  validationErrors: UploadValidationError[] = [];

  /**
   * Detailed processing result with success/failure breakdown
   *
   * @generated from field: geneo.cms.teacher.questions.upload.apis.ProcessingResult processing_result = 5;
   */
  processingResult?: ProcessingResult;

  /**
   * Summary of uploaded questions and question banks
   *
   * @generated from field: geneo.cms.teacher.questions.upload.apis.UploadSummary upload_summary = 6;
   */
  uploadSummary?: UploadSummary;

  constructor(data?: PartialMessage<UpsertTeacherQuestionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.UpsertTeacherQuestionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(APIResponse_StatusEnum) },
    { no: 2, name: "code", kind: "enum", T: proto3.getEnumType(APIResponse_CodeEnum) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "validation_errors", kind: "message", T: UploadValidationError, repeated: true },
    { no: 5, name: "processing_result", kind: "message", T: ProcessingResult },
    { no: 6, name: "upload_summary", kind: "message", T: UploadSummary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpsertTeacherQuestionsResponse {
    return new UpsertTeacherQuestionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpsertTeacherQuestionsResponse {
    return new UpsertTeacherQuestionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpsertTeacherQuestionsResponse {
    return new UpsertTeacherQuestionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpsertTeacherQuestionsResponse | PlainMessage<UpsertTeacherQuestionsResponse> | undefined, b: UpsertTeacherQuestionsResponse | PlainMessage<UpsertTeacherQuestionsResponse> | undefined): boolean {
    return proto3.util.equals(UpsertTeacherQuestionsResponse, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.ProcessingResult
 */
export class ProcessingResult extends Message<ProcessingResult> {
  /**
   * Successfully saved questions using original Question message
   *
   * @generated from field: repeated geneo.content.db.Question successful = 1;
   */
  successful: Question[] = [];

  /**
   * Failed questions with error details
   *
   * @generated from field: repeated geneo.cms.teacher.questions.upload.apis.UploadValidationError failed = 2;
   */
  failed: UploadValidationError[] = [];

  /**
   * Overall statistics
   *
   * @generated from field: geneo.cms.teacher.questions.upload.apis.SheetSummary summary = 3;
   */
  summary?: SheetSummary;

  constructor(data?: PartialMessage<ProcessingResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.ProcessingResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "successful", kind: "message", T: Question, repeated: true },
    { no: 2, name: "failed", kind: "message", T: UploadValidationError, repeated: true },
    { no: 3, name: "summary", kind: "message", T: SheetSummary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProcessingResult {
    return new ProcessingResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProcessingResult {
    return new ProcessingResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProcessingResult {
    return new ProcessingResult().fromJsonString(jsonString, options);
  }

  static equals(a: ProcessingResult | PlainMessage<ProcessingResult> | undefined, b: ProcessingResult | PlainMessage<ProcessingResult> | undefined): boolean {
    return proto3.util.equals(ProcessingResult, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.SheetSummary
 */
export class SheetSummary extends Message<SheetSummary> {
  /**
   * @generated from field: int32 total_processed = 1;
   */
  totalProcessed = 0;

  /**
   * @generated from field: int32 success_count = 2;
   */
  successCount = 0;

  /**
   * @generated from field: int32 failure_count = 3;
   */
  failureCount = 0;

  constructor(data?: PartialMessage<SheetSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.SheetSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_processed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "success_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "failure_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SheetSummary {
    return new SheetSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SheetSummary {
    return new SheetSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SheetSummary {
    return new SheetSummary().fromJsonString(jsonString, options);
  }

  static equals(a: SheetSummary | PlainMessage<SheetSummary> | undefined, b: SheetSummary | PlainMessage<SheetSummary> | undefined): boolean {
    return proto3.util.equals(SheetSummary, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.UploadValidationError
 */
export class UploadValidationError extends Message<UploadValidationError> {
  /**
   * Excel row number (1-indexed)
   *
   * @generated from field: int32 row_number = 1;
   */
  rowNumber = 0;

  /**
   * Question text or identifier
   *
   * @generated from field: string row_identifier = 2;
   */
  rowIdentifier = "";

  /**
   * List of error messages for this row
   *
   * @generated from field: repeated string error_messages = 3;
   */
  errorMessages: string[] = [];

  /**
   * Help text for fixing the error
   *
   * @generated from field: string suggestion = 4;
   */
  suggestion = "";

  /**
   * JSON-encoded original row data for audit
   *
   * @generated from field: bytes original_data = 5;
   */
  originalData = new Uint8Array(0);

  constructor(data?: PartialMessage<UploadValidationError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.UploadValidationError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "row_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "row_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "error_messages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "suggestion", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "original_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadValidationError {
    return new UploadValidationError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadValidationError {
    return new UploadValidationError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadValidationError {
    return new UploadValidationError().fromJsonString(jsonString, options);
  }

  static equals(a: UploadValidationError | PlainMessage<UploadValidationError> | undefined, b: UploadValidationError | PlainMessage<UploadValidationError> | undefined): boolean {
    return proto3.util.equals(UploadValidationError, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.UploadSummary
 */
export class UploadSummary extends Message<UploadSummary> {
  /**
   * Total number of questions successfully created (all-or-nothing)
   *
   * @generated from field: int32 total_questions_created = 1;
   */
  totalQuestionsCreated = 0;

  /**
   * Question banks created
   *
   * @generated from field: repeated geneo.content.db.QuestionBank question_banks = 2;
   */
  questionBanks: QuestionBank[] = [];

  /**
   * Module-QB tag mappings created
   *
   * @generated from field: repeated geneo.content.db.ModuleQuestionBankTag module_question_bank_tags = 3;
   */
  moduleQuestionBankTags: ModuleQuestionBankTag[] = [];

  constructor(data?: PartialMessage<UploadSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.UploadSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_questions_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "question_banks", kind: "message", T: QuestionBank, repeated: true },
    { no: 3, name: "module_question_bank_tags", kind: "message", T: ModuleQuestionBankTag, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadSummary {
    return new UploadSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadSummary {
    return new UploadSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadSummary {
    return new UploadSummary().fromJsonString(jsonString, options);
  }

  static equals(a: UploadSummary | PlainMessage<UploadSummary> | undefined, b: UploadSummary | PlainMessage<UploadSummary> | undefined): boolean {
    return proto3.util.equals(UploadSummary, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.DeleteTeacherQuestionsRequest
 */
export class DeleteTeacherQuestionsRequest extends Message<DeleteTeacherQuestionsRequest> {
  /**
   * Array of question IDs to delete
   *
   * @generated from field: repeated string question_ids = 1;
   */
  questionIds: string[] = [];

  /**
   * Teacher requesting deletion (for authorization)
   *
   * @generated from field: int64 teacher_id = 2;
   */
  teacherId = protoInt64.zero;

  /**
   * School ID for validation
   *
   * @generated from field: int32 school_id = 3;
   */
  schoolId = 0;

  /**
   * If true, marks as deleted; if false, permanently removes (default: true)
   *
   * @generated from field: optional bool soft_delete = 4;
   */
  softDelete?: boolean;

  /**
   * If true, also removes questions from associated question banks (default: true)
   *
   * @generated from field: optional bool remove_from_question_banks = 5;
   */
  removeFromQuestionBanks?: boolean;

  constructor(data?: PartialMessage<DeleteTeacherQuestionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.DeleteTeacherQuestionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "soft_delete", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "remove_from_question_banks", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTeacherQuestionsRequest {
    return new DeleteTeacherQuestionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTeacherQuestionsRequest {
    return new DeleteTeacherQuestionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTeacherQuestionsRequest {
    return new DeleteTeacherQuestionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTeacherQuestionsRequest | PlainMessage<DeleteTeacherQuestionsRequest> | undefined, b: DeleteTeacherQuestionsRequest | PlainMessage<DeleteTeacherQuestionsRequest> | undefined): boolean {
    return proto3.util.equals(DeleteTeacherQuestionsRequest, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.DeleteTeacherQuestionsResponse
 */
export class DeleteTeacherQuestionsResponse extends Message<DeleteTeacherQuestionsResponse> {
  /**
   * @generated from field: geneo.common.db.APIResponse.StatusEnum status = 1;
   */
  status = APIResponse_StatusEnum.STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.common.db.APIResponse.CodeEnum code = 2;
   */
  code = APIResponse_CodeEnum.UNDEFINED;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * Summary of deletion operation
   *
   * @generated from field: geneo.cms.teacher.questions.upload.apis.DeleteSummary delete_summary = 4;
   */
  deleteSummary?: DeleteSummary;

  constructor(data?: PartialMessage<DeleteTeacherQuestionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.DeleteTeacherQuestionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(APIResponse_StatusEnum) },
    { no: 2, name: "code", kind: "enum", T: proto3.getEnumType(APIResponse_CodeEnum) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "delete_summary", kind: "message", T: DeleteSummary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTeacherQuestionsResponse {
    return new DeleteTeacherQuestionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTeacherQuestionsResponse {
    return new DeleteTeacherQuestionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTeacherQuestionsResponse {
    return new DeleteTeacherQuestionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTeacherQuestionsResponse | PlainMessage<DeleteTeacherQuestionsResponse> | undefined, b: DeleteTeacherQuestionsResponse | PlainMessage<DeleteTeacherQuestionsResponse> | undefined): boolean {
    return proto3.util.equals(DeleteTeacherQuestionsResponse, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.DeleteSummary
 */
export class DeleteSummary extends Message<DeleteSummary> {
  /**
   * Total number of questions requested for deletion
   *
   * @generated from field: int32 total_requested = 1;
   */
  totalRequested = 0;

  /**
   * Number of questions successfully deleted
   *
   * @generated from field: int32 successfully_deleted = 2;
   */
  successfullyDeleted = 0;

  /**
   * Number of questions that failed to delete
   *
   * @generated from field: int32 failed_to_delete = 3;
   */
  failedToDelete = 0;

  /**
   * Details of deleted questions
   *
   * @generated from field: repeated geneo.cms.teacher.questions.upload.apis.DeletedQuestionInfo deleted_questions = 4;
   */
  deletedQuestions: DeletedQuestionInfo[] = [];

  /**
   * Details of failed deletions
   *
   * @generated from field: repeated geneo.cms.teacher.questions.upload.apis.DeleteFailureInfo failed_deletions = 5;
   */
  failedDeletions: DeleteFailureInfo[] = [];

  /**
   * Question banks that were modified
   *
   * @generated from field: repeated string affected_question_bank_ids = 6;
   */
  affectedQuestionBankIds: string[] = [];

  constructor(data?: PartialMessage<DeleteSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.DeleteSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_requested", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "successfully_deleted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "failed_to_delete", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "deleted_questions", kind: "message", T: DeletedQuestionInfo, repeated: true },
    { no: 5, name: "failed_deletions", kind: "message", T: DeleteFailureInfo, repeated: true },
    { no: 6, name: "affected_question_bank_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSummary {
    return new DeleteSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSummary {
    return new DeleteSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSummary {
    return new DeleteSummary().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSummary | PlainMessage<DeleteSummary> | undefined, b: DeleteSummary | PlainMessage<DeleteSummary> | undefined): boolean {
    return proto3.util.equals(DeleteSummary, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.DeletedQuestionInfo
 */
export class DeletedQuestionInfo extends Message<DeletedQuestionInfo> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * First 100 chars for reference
   *
   * @generated from field: string question_text = 2;
   */
  questionText = "";

  /**
   * Whether question was part of any question banks
   *
   * @generated from field: bool was_in_question_banks = 3;
   */
  wasInQuestionBanks = false;

  /**
   * Question banks it was removed from
   *
   * @generated from field: repeated string removed_from_question_bank_ids = 4;
   */
  removedFromQuestionBankIds: string[] = [];

  constructor(data?: PartialMessage<DeletedQuestionInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.DeletedQuestionInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "was_in_question_banks", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "removed_from_question_bank_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletedQuestionInfo {
    return new DeletedQuestionInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletedQuestionInfo {
    return new DeletedQuestionInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletedQuestionInfo {
    return new DeletedQuestionInfo().fromJsonString(jsonString, options);
  }

  static equals(a: DeletedQuestionInfo | PlainMessage<DeletedQuestionInfo> | undefined, b: DeletedQuestionInfo | PlainMessage<DeletedQuestionInfo> | undefined): boolean {
    return proto3.util.equals(DeletedQuestionInfo, a, b);
  }
}

/**
 * @generated from message geneo.cms.teacher.questions.upload.apis.DeleteFailureInfo
 */
export class DeleteFailureInfo extends Message<DeleteFailureInfo> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * Why deletion failed (e.g., "Not found", "Unauthorized", "Already deleted")
   *
   * @generated from field: string reason = 2;
   */
  reason = "";

  /**
   * Additional error information
   *
   * @generated from field: string error_details = 3;
   */
  errorDetails = "";

  constructor(data?: PartialMessage<DeleteFailureInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.cms.teacher.questions.upload.apis.DeleteFailureInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "error_details", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteFailureInfo {
    return new DeleteFailureInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteFailureInfo {
    return new DeleteFailureInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteFailureInfo {
    return new DeleteFailureInfo().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteFailureInfo | PlainMessage<DeleteFailureInfo> | undefined, b: DeleteFailureInfo | PlainMessage<DeleteFailureInfo> | undefined): boolean {
    return proto3.util.equals(DeleteFailureInfo, a, b);
  }
}

